import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press3',
  templateUrl: './notice-press3.component.html',
  styleUrls: ['./notice-press3.component.scss']
})
export class NoticePress3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
